'use strict';

var _ = require('lodash');
var toastr = require('toastr');
function ConfigurationUserDefinedRefDataGridToolbarFunctionsService($q, $log, urdConstants, restangular) {
  var deleteService = restangular.service('configuration').one('hep').one('key');
  var DTD_ROWS_NUMBER = 366;
  var referenceMetricsMap = require('../config/reference-metrics.json');
  var marketMetricsMap = referenceMetricsMap.market;
  var flightMetricsMap = referenceMetricsMap.flight;
  function prepareFunctionLevel(type, status, dtd) {
    var dtdValues = _.transform(dtd, function (result, item) {
      result.push(item[type]);
    }, []);
    if (_.compact(dtdValues).length === 0) {
      return null;
    }
    return {
      statusType: status,
      functionType: type,
      metricValuesCorrespondingToDTD: dtdValues
    };
  }
  function replacer(metric) {
    return metric ? metric.replace(/ /g, '_') : metric;
  }
  function getMarketReferenceMetric(referenceMetric, param) {
    param = param || 'value';
    return _.get(marketMetricsMap, [replacer(referenceMetric), param]);
  }
  function getFlightReferenceMetric(referenceMetric, param) {
    param = param || 'value';
    return _.get(flightMetricsMap, [replacer(referenceMetric), param]);
  }
  function prepareMarketPayload(data) {
    var origDest = data.market ? data.market.split('-') : '';
    return {
      type: urdConstants.HEP_TYPE.MARKET,
      attributes: {
        marketEntity: data.marketEntity,
        marketProduct: data.marketProduct,
        origin: origDest[0],
        destination: origDest[1],
        season: data.demandSeason,
        dayOfWeekGroup: data.dowGroup,
        referenceMetric: getMarketReferenceMetric(data.referenceMetric),
        pos: data.pos
      },
      properties: {
        profile: {
          functionLevelURDs: _.compact([prepareFunctionLevel('MIN', data.status, data.dtds), prepareFunctionLevel('MAX', data.status, data.dtds), prepareFunctionLevel('AVG', data.status, data.dtds)])
        }
      }
    };
  }
  function prepareFlightPayload(data) {
    var origDest = data.flightLeg ? data.flightLeg.split('-') : '';
    return {
      type: urdConstants.HEP_TYPE.FLIGHT,
      attributes: {
        airlineCode: data.airline,
        flightEntity: data.flightEntity,
        cabinCode: data.cabin,
        origin: origDest[0],
        destination: origDest[1],
        number: data.flightNumber,
        season: data.season,
        dayOfWeekGroup: data.dowGroup,
        referenceMetric: getFlightReferenceMetric(data.referenceMetric)
      },
      properties: {
        profile: {
          functionLevelURDs: _.compact([prepareFunctionLevel('MIN', data.status, data.dtds), prepareFunctionLevel('MAX', data.status, data.dtds), prepareFunctionLevel('AVG', data.status, data.dtds)])
        }
      }
    };
  }
  function initializeOldVariables(loadedData, rowid, columns) {
    loadedData[rowid]._old = {};
    _.forEach(columns, function (col) {
      loadedData[rowid]._old[col.datafield] = undefined;
    });
  }
  function generateEmptyDtds() {
    return _.times(DTD_ROWS_NUMBER, function (index) {
      return {
        DTD: index,
        AVG: '',
        MAX: '',
        MIN: ''
      };
    });
  }
  function addURDRow(loadedData, columns) {
    loadedData.unshift({
      isNewlyAdded: true
    });
    initializeOldVariables(loadedData, 0, columns);
    loadedData[0].status = 'DISABLED';
    loadedData[0].dtds = generateEmptyDtds();
  }
  function duplicateURDRow(loadedData, rowId, columns) {
    var oldRow = loadedData[rowId];
    var newRow = _.clone(oldRow);
    newRow.isRowEditable = true;
    newRow.isNewlyAdded = true;
    loadedData.splice(rowId, 0, newRow);
    initializeOldVariables(loadedData, rowId, columns);
  }
  function removeURDRow(loadedData, type, hepKeyCreator) {
    var params = {
      type: type
    };
    var promises = [];
    for (var i = 0; i < loadedData.length; i++) {
      params.hepKey = '"' + hepKeyCreator(loadedData[i]) + '"';
      promises.push(deleteService.remove(params));
    }
    return $q.all(promises).then(showSaveSuccessMessage)["catch"](showSaveErrorMessage);
  }
  function hasDuplicates(rows, modifiedRows, hepKeyCreator) {
    var modifiedKeys = _.map(modifiedRows, hepKeyCreator);
    var duplicates = false;
    _.forEach(rows, function (row) {
      if (!row._old && _.includes(modifiedKeys, hepKeyCreator(row))) {
        duplicates = true;
        return false;
      }
    });
    return duplicates;
  }
  function isMandatoryColumnsNotPopulated(type, row) {
    var isError = false;
    var mandatoryColumns = {};
    mandatoryColumns[urdConstants.HEP_TYPE.MARKET] = ['marketProduct', 'referenceMetric'];
    mandatoryColumns[urdConstants.HEP_TYPE.FLIGHT] = ['cabin', 'referenceMetric'];
    _.forEach(mandatoryColumns[type], function (columnName) {
      if (_.isEmpty(row[columnName])) {
        isError = true;
        return false;
      }
    });
    return isError;
  }

  /**
   * When cell in first row has a value, other cells should be empty to show an error
   * @param firstRowValueIsEmpty
   * @param cellValue
   * @returns {boolean}
   */
  function isColumnNotPopulated(firstRowValueIsEmpty, cellValue) {
    var isNotEmpty = _.isNumber(cellValue) || !_.isEmpty(cellValue);
    return firstRowValueIsEmpty ? isNotEmpty : !isNotEmpty;
  }
  function isDtdLevelNotPopulated(level, dtds) {
    var isError = false;
    var firstValue = dtds[0][level];
    var firstRowValueIsEmpty = !_.isNumber(firstValue) && _.isEmpty(firstValue);
    _.forEach(dtds, function (dtd) {
      if (isColumnNotPopulated(firstRowValueIsEmpty, dtd[level])) {
        isError = true;
      }
    });
    if (!isError && !_.includes([0, 366], dtds.length)) {
      isError = true;
    }
    return isError;
  }
  function validateRowAttributes(type, row) {
    if (isMandatoryColumnsNotPopulated(type, row)) {
      return 'All mandatory columns need to be populated.';
    }
  }
  function validateDtds(dtds) {
    if (isDtdLevelNotPopulated('MIN', dtds)) {
      return 'Every cell in MIN column needs to be populated.';
    }
    if (isDtdLevelNotPopulated('MAX', dtds)) {
      return 'Every cell in MAX column needs to be populated.';
    }
    if (isDtdLevelNotPopulated('AVG', dtds)) {
      return 'Every cell in AVG column needs to be populated.';
    }
  }

  /**
   * Validate URD record data
   * @param type
   * @param rows
   * @param modifiedRows
   * @param hepKeyCreator
   * @returns {deferred.promise|{then, catch, finally}}
   */
  function validate(type, rows, modifiedRows, hepKeyCreator) {
    var deferred = $q.defer();
    var errorMsg = '';
    if (hasDuplicates(rows, modifiedRows, hepKeyCreator)) {
      errorMsg = 'Duplicate record exists';
    } else {
      _.forEach(modifiedRows, function (row) {
        errorMsg = validateRowAttributes(type, row);
        if (errorMsg) {
          return false;
        }
        errorMsg = validateDtds(row.dtds);
        if (errorMsg) {
          return false;
        }
      });
    }
    if (errorMsg) {
      deferred.reject(errorMsg);
    } else {
      deferred.resolve({
        type: type,
        modifiedRows: modifiedRows,
        hepKeyCreator: hepKeyCreator
      });
    }
    return deferred.promise;
  }

  /**
   * Identify and delete rows that needs to be removed from server before new values will be sent.
   * @param {Object} data
   * @returns {*}
   */
  function deleteRowsWhenKeyValuesWereModified(data) {
    var rowsWithOldValues = _.transform(data.modifiedRows, function (result, row) {
      if (row.keyValuesModified && !row.isNewlyAdded) {
        result.push(_.merge({}, row, row._old));
      }
    }, []);
    if (rowsWithOldValues.length) {
      return removeURDRow(rowsWithOldValues, data.type, data.hepKeyCreator).then(function () {
        return data;
      });
    } else {
      return $q.when(data);
    }
  }

  /**
   * Prepare payload and send it to server
   * @param {Object} data
   * @returns {*}
   */
  function savePayload(data) {
    var payloadTransformer = data.type === urdConstants.HEP_TYPE.MARKET ? prepareMarketPayload : prepareFlightPayload;
    var payload = _.map(data.modifiedRows, payloadTransformer);
    return restangular.one('configuration').one('hep').one('bulk').customPUT({
      value: payload
    }, undefined, {
      upsert: true
    });
  }

  /**
   * Return rows with modified values (in main grid or in DTD modal)
   * @param type
   * @param {Array} data
   * @returns {[]}
   */
  function getModifiedRows(type, data) {
    return _.transform(data, function (result, row) {
      var modifiedRow;
      if (_.has(row, '_old')) {
        modifiedRow = _.cloneDeep(row);
        if (!_.isEqual(['dtds'], _.keys(row._old))) {
          modifiedRow.keyValuesModified = true;
        }
        result.push(modifiedRow);
      }
    }, []);
  }

  /**
   * Save rows modified by user
   * @param {string} type - HEP type
   * @param {Array} data - data from main grid
   * @param {Function} hepKeyCreator - function to generate hep key
   * @returns {*}
   */
  function save(type, data, hepKeyCreator) {
    var modifiedRows = getModifiedRows(type, data);
    if (modifiedRows.length) {
      return validate(type, data, modifiedRows, hepKeyCreator).then(deleteRowsWhenKeyValuesWereModified).then(savePayload).then(showSaveSuccessMessage)["catch"](showSaveErrorMessage);
    } else {
      return $q.reject();
    }
  }
  function showSaveSuccessMessage() {
    toastr.success('Successfully saved configuration changes.');
  }
  function showSaveErrorMessage(msg) {
    var errorMsg = '';
    if (_.has(msg, 'data.message')) {
      errorMsg = msg.data.message;
    } else {
      errorMsg = msg;
    }
    $log.error('ConfigurationUserDefinedRefDataGridToolbarFunctionsService: showSaveErrorMessage - ' + errorMsg);
    toastr.error(errorMsg);
    return $q.reject();
  }
  return {
    prepareMarketPayload: prepareMarketPayload,
    prepareFlightPayload: prepareFlightPayload,
    duplicateURDRow: duplicateURDRow,
    addURDRow: addURDRow,
    removeURDRow: removeURDRow,
    save: save,
    getMarketReferenceMetric: getMarketReferenceMetric,
    getFlightReferenceMetric: getFlightReferenceMetric,
    validateRowAttributes: validateRowAttributes,
    validateDtds: validateDtds
  };
}
ConfigurationUserDefinedRefDataGridToolbarFunctionsService.$inject = ['$q', '$log', 'UrdConstants', 'Restangular'];
module.exports = ConfigurationUserDefinedRefDataGridToolbarFunctionsService;